
export const environment = {
  production: false,
  appVersion: require('../../package.json').version + '-dev',
  blobUrl: 'https://lumuatsta.blob.core.windows.net/uatcontainer',
  apiUrl: 'https://lum-dev-api.azurewebsites.net/customer2/api/',
  apiDomain: 'lum-dev-api.azurewebsites.net',
  emailForRoutes: 'jO6h51tEHyOfOom9E46YJwUj1yixET/JAHA9WVUSr8w=',
  passwordForRoutes: 'FAqpaioFtYP9P+ZpmkgRDCLjXFg0SSkgyWdU9JIotFI=',
  pathForRoutes: '/customer/api/CustomerConsultation/GetRedirectUrlAsync',
  encryptSecretKey: "Do7wF66aPjqa6i7u",
  ivKey: "Ln_Zn-zm7E9u@&TF",
  googleProvider: '7364524375-9gtq562mf9k9nfnm7ecp5dmao1a41s3g.apps.googleusercontent.com',
  facebookProvider: '656860812284631',//'404913954835409',
  accessCode: 'ATQR75FA88CK38RQKC',
  actionLink: 'https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction',
  baseUrl: 'https://lum-dev-customer-linuxapp.azurewebsites.net/',
  baseApiURl: 'https://lum-dev-customer-linuxapp.azurewebsites.net',
  webUrlForDistributor: 'https://lumdevstadistributor.z30.web.core.windows.net/',
  snapmintUrl: "https://sandboxapi.snapmint.com/v3/public/online_checkout",
  merchantId:2663,
  merchantIdB:4791
  // baseUrl: 'http://localhost:4000/'
};
